<p class="expireText">
  Your Transaction will expire in
  <span class="time">
    {{ getTimer }}
  </span>
  <img src="../../../assets/svg/clock.svg" alt="clock" />
</p>
